import { useEffect, useState } from 'react';
import axios from 'axios';
import { DEFAULT_PAYMENT_METHODS } from '../utils/paymentMethods';

// The company's payment methods from GET /api/settings/payment-methods, deleted
// entries included (they still label old stops). The built-in list until the
// request answers, and if it fails.
//
// Fetched on each mount rather than cached for the page load, so a method
// added in Settings shows on the next screen without a reload.
export default function usePaymentMethods() {
  const [methods, setMethods] = useState(DEFAULT_PAYMENT_METHODS);
  useEffect(() => {
    let live = true;
    axios.get(`${process.env.REACT_APP_API_URL}/api/settings/payment-methods`)
      .then((response) => {
        if (live && Array.isArray(response.data) && response.data.length > 0) setMethods(response.data);
      })
      .catch(() => {});
    return () => { live = false; };
  }, []);
  return methods;
}
